import Vue from 'vue'
import Vuex from 'vuex'

import adminData from '@store/modules/admin-data'
import aggregatedSkills from '@store/modules/aggregated-skills'
import auth from '@store/modules/auth'
import colorTheme from '@store/modules/color-theme'
import globalVariables from '@store/modules/global-variables'
import notification from '@store/modules/notification'
import onboarding from '@store/modules/onboarding'
import routeHistory from '@store/modules/route-history'
import searchExpert from '@store/modules/search-expert'
import serviceParams from '@store/modules/service-params'
import skills from '@store/modules/skills'
import teamup from '@store/modules/teamup'
import tenant from '@store/modules/tenant'
import tenantDiagnose from '@store/modules/tenant-diagnose'
import tenantParams from '@store/modules/tenant-params'
import tenantUser from '@store/modules/tenant-user'
import tenantUserDiagnose from '@store/modules/tenant-user-diagnose'
import tenantUsers from '@store/modules/tenant-users'
import tenantUserSkills from '@store/modules/tenant-user-skills'
import triggers from '@store/modules/triggers'
import user from '@store/modules/user'
import userSuggestions from '@store/modules/user-suggestions'
import window from '@store/modules/window'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    adminData,
    aggregatedSkills,
    auth,
    colorTheme,
    globalVariables,
    notification,
    onboarding,
    routeHistory,
    searchExpert,
    serviceParams,
    skills,
    teamup,
    tenant,
    tenantDiagnose,
    tenantParams,
    tenantUser,
    tenantUserDiagnose,
    tenantUsers,
    tenantUserSkills,
    triggers,
    user,
    userSuggestions,
    window,
  },
});

export default store;
